import { addDays, format, parseISO, startOfWeek } from "date-fns";

export const ymd = (d) => format(d, "yyyy-MM-dd");
export const mondayOf = (d) => startOfWeek(d, { weekStartsOn: 1 });
export const weekDays = (monday) => Array.from({ length: 7 }, (_, i) => addDays(monday, i));
export const fmtTime = (iso) => (iso ? iso.slice(11, 16) : "");
export const fmtDay = (iso) => format(parseISO(iso), "EEE d MMM");
export const isOvernight = (s) => s.start.slice(0, 10) !== s.end.slice(0, 10);
export const hoursBetween = (a, b) => (parseISO(b) - parseISO(a)) / 36e5;

export function buildRange(date, startTime, endTime, nextDay = false) {
  const start = `${date}T${startTime}`;
  const endDate = nextDay || endTime <= startTime ? ymd(addDays(parseISO(date), 1)) : date;
  return { start, end: `${endDate}T${endTime}` };
}
